module.exports = __webpack_public_path__ + "cdab16fac2243c5c872dfc78527812ab.pdf";